// Common
import { default as init } from "./common/base";

//Vendors
import 'lazysizes';
import { Modal } from "bootstrap";


// Helpers
import { Component } from "./helpers/component";
import { ZEvents } from "./helpers/events";
import { StoreManager } from "./helpers/store";

// Components
import { Header } from "../../components/header/header";
import { Icon } from "../../components/icon/icon";
import { Button } from "../../components/btn/btn";
import { BackButton } from "../../components/backbtn/backbtn";

//Load app store
const storeManager = new StoreManager();

//Loading events
ZEvents.loadCustomEvents();

// Registering components
Component.register("Header", Header);
Component.register("Icon", Icon);
Component.register("Button", Button);
Component.register("BackButton", BackButton);

init();
